export default __webpack_public_path__ + "static/media/court-bg.a822c180.jpg";